export const LOADED = 'loaded';
export const FAILED = 'failed';
export const LOADING = 'loading';
